import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import getRuntimeEnv from 'helpers/env';

import styled, {
  createGlobalStyle,
  ThemeProvider,
} from 'styled-components/macro';

import configureStore from 'redux/store';

import AppRoutes from './AppRoutes';

import base from 'styles/global/base';
import typography from 'styles/global/typography/typography';
import colors from 'styles/themes/colors';
import variables from 'styles/themes/variables';
import animations from 'styles/global/animations';

const { store, persistor }: any = configureStore();

const GlobalStyle = createGlobalStyle`
  ${base}
  ${typography}
  ${animations}
`;

/** IE11 min-height bug with flexbox can be solved by wrapping it with another flex contaner (#root).
 * @see https://codepen.io/chriswrightdesign/pen/emQNGZ/
 */
const AppWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  min-height: 100vh;
  position: relative;
`;

const App: React.FC<never> = () => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={null}>
        <Router>
          <ThemeProvider theme={{ ...colors, ...variables }}>
            {/* YOU NEED THIS FRAGMENT! ThemeProvider only supports one child */}
            <>
              <GlobalStyle />
              <Helmet
                defaultTitle="Opus"
                titleTemplate="%s - Opus"
                defer={false}
                meta={[
                  {
                    name: 'robots',
                    content: 'noindex, nofollow',
                  },
                  {
                    name: 'description',
                    content:
                      'Opus is a Warner Music Global industry performance dashboard',
                  },
                ]}
              />
              <AppWrapper>
                <Route
                  render={(renderProps: any): any => (
                    <AppRoutes {...renderProps} />
                  )}
                />
              </AppWrapper>
            </>
          </ThemeProvider>
        </Router>
      </PersistGate>
    </Provider>
  );
};
export default App;
